import api from "../../api.ts";
import {unwrapData} from "../../apiResponse.ts";

export enum TelcoStatus {
    ONLINE = 'ONLINE',
    TALKING = 'TALKING',
    OFFLINE = 'OFFLINE',
    UNKNOWN = 'UNKNOWN',
    DND = 'DND',
}
export enum TelcoStatusName {
    ONLINE = 'Online',
    TALKING = 'Talking',
    OFFLINE = 'Offline',
    UNKNOWN = 'Unknown',
    DND = 'Do Not Disturb',
}
    
interface CustomUserStatus {
    userId: string;
    name: string;
    icon: string;
    dueDate: string;
}

interface TelcoUserStatus {
    status: TelcoStatus;
    lastUpdated: string;
}

export interface DoNotDisturbUserStatus {
    userId: string;
    enabled: boolean;
    dueDate: string | null;
    lastUpdatedAt: string | null;
}

type MeetingUserStatus = {
    status: string;
    dateFrom: string;
    dateTo: string;
};

export interface UserStatus {
    userId: string;
    firstName: string;
    lastName: string;
    position: string;
    customUserStatus: CustomUserStatus;
    telcoUserStatus: TelcoUserStatus;
    doNotDisturbUserStatus: DoNotDisturbUserStatus;
    meetingUserStatus: MeetingUserStatus;
}






export const teamApi = api.injectEndpoints({
    endpoints: (builder) => ({

        getStatuses: builder.query<UserStatus[], { users: any }>({
            query: ({ users }) => {
                if (!users || users.length === 0) return ;
                return {
                    url: 'api/v1/statuses',
                    params: { users: users.join(',') },
                };
            },
            transformResponse: (response: any) => {
                return unwrapData(response).statuses;
            },
            providesTags: ['Statuses']
        }),

        changeStatus: builder.mutation<any, { data: any , userId: string | null }>({
            query: ({ data, userId }) => {
                return {
                    url: `api/v1/statuses/user/${userId}/custom`,
                    method: 'PATCH',
                    body: data,
                };
            },
        }),
    }),
});


export const {
    useGetStatusesQuery,
    useLazyGetStatusesQuery,
    useChangeStatusMutation,
} = teamApi;
